export default "__VITE_ASSET__BHa3Prxo__"